import apiClient from '../plugins/api_client.js'
import store from "../store/index.js"

export const baseUrl = process.env.VUE_APP_URL_API+"/reasons";

export default class ReasonsService {

    getReasons() {
      return new Promise( (resolve, reject) => {
          apiClient.get(`${baseUrl}`,
          {headers: {'Authorization': 'Bearer ' + store.state.token}})
          .then(function(response){
            resolve(response.data);
          })
          .catch(function(error){
            console.log(error)
            reject(error);
          });
      })
    }
}